// Fills the related-products row up to 4 cards using Shopify's own
// recommendations once same-category products (server-rendered by
// sections/gsb-related-products.liquid) do not reach 4 on their own.
// Shopify's recommendation data is only available via its JSON
// endpoint, not to server-side Liquid outside the stock
// product-recommendations section, so this runs client-side.
(function () {
  function buildCard(p) {
    var variant = p.variants && p.variants[0];
    var image = p.featured_image || (p.images && p.images[0]);
    var imageUrl = image ? image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') : '';
    var a = document.createElement('a');
    a.href = p.url;
    a.className = 'gsb-related-card';
    a.setAttribute('data-product-id', p.id);

    var price = variant ? '₹' + (variant.price / 1).toFixed(2).replace(/\.00$/, '.00') : '';

    a.innerHTML =
      '<span class="gsb-related-card__image">' +
        (imageUrl ? '<img src="' + imageUrl + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
      '</span>' +
      '<span class="gsb-related-card__body">' +
        '<span class="gsb-related-card__title">' + (p.title || '') + '</span>' +
        '<span class="gsb-related-card__price">' + price + '</span>' +
      '</span>';
    return a;
  }

  function run() {
    var grid = document.querySelector('[data-related-grid]');
    if (!grid) return;

    var shown = grid.querySelectorAll('.gsb-related-card').length;
    var needed = 4 - shown;
    if (needed <= 0) return;

    var currentId = grid.getAttribute('data-current-id');
    var excludeHandle = grid.getAttribute('data-exclude-handle');
    var shownIds = Array.prototype.map.call(grid.querySelectorAll('[data-product-id]'), function (el) {
      return el.getAttribute('data-product-id');
    });

    fetch('/recommendations/products.json?product_id=' + currentId + '&limit=10&intent=related')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var products = (data && data.products) || [];
        var added = 0;
        for (var i = 0; i < products.length && added < needed; i++) {
          var p = products[i];
          if (String(p.id) === String(currentId)) continue;
          if (p.handle === excludeHandle) continue;
          if (shownIds.indexOf(String(p.id)) !== -1) continue;
          grid.appendChild(buildCard(p));
          added++;
        }
      })
      .catch(function () {
        // No fallback available; same-category cards already shown stand alone.
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
